import React, { Fragment, useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useSelector, useDispatch } from "react-redux";
import {
  enrolUser,
  userSelector,
  clearState,
} from "../features/User/UserSlice";
import { useHistory, useParams } from "react-router-dom";
import toast from "react-hot-toast";
import AuthNavBar from "../features/components/nav/AuthNav";
import Swal from "sweetalert2";
import madagascarData from "../features/assets/liste_commune_par_district.json";
import axios from "axios";
import { useTranslation } from "react-i18next";

const ModifyBiodata = () => {
  const { t, i18n } = useTranslation();
  const countryLabel = (country) => {
    try {
      return (
        new Intl.DisplayNames([i18n.language], { type: "region" }).of(
          country.code,
        ) || country.name
      );
    } catch (error) {
      return country.name;
    }
  };
  const dispatch = useDispatch();
  const { register, handleSubmit, setValue } = useForm();
  const history = useHistory();
  const [showModal, setShowModal] = useState(true);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const { isFetching, isSuccess, isError, errorMessage, successMessage } =
    useSelector(userSelector);

  const [editableFields, setEditableFields] = useState({
    firstName: false,
    lastName: false,
    dob: false,
    phoneNumber: false,
    email: false,
    residenceAddress: false,
  });

  // Helper function to format date for input field
  const formatDateForInput = (dateString) => {
    const date = new Date(dateString);
    return date.toISOString().split("T")[0];
  };
  // Add state for storing API data
  const [userData, setUserData] = useState(null);
  const trackingID = localStorage.getItem("trackingIDFromServer");
  const token = localStorage.getItem("token");
  // Fetch user data from API
  useEffect(() => {
    const token = localStorage.getItem("token");
    const trackingID = localStorage.getItem("trackingIDFromServer");
    const fetchUserData = async () => {
      try {
        const response = await axios.get(
          `https://idms-preenrol.e-citizen.org/api/v1/enrolment/trackingId/${trackingID}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          },
        );
        setUserData(response.data);
        setLoading(false);

        // Set initial form values
        const formFields = [
          "firstName",
          "lastName",
          "dob",
          "gender",
          "phoneNumber",
          "email",
          "maidenName",
          "contactOwner",
          "parentLastName",
          "parentFirstName",
          "parentDob",
          "nui",
          "residenceAddress",
          "houseAddress",
          "region",
          "district",
          "province",
          "placeOfBirth",
        ];

        formFields.forEach((field) => {
          if (response.data[field]) {
            setValue(field, response.data[field]);
          }
        });

        // Special handling for date fields
        if (response.data.dob) {
          setValue("dob", formatDateForInput(response.data.dob));
        }
        if (response.data.parentDob) {
          setValue("parentDob", formatDateForInput(response.data.parentDob));
        }

        // Check if user is under 18
        if (response.data.dob) {
          checkAge(new Date(response.data.dob));
        }
        // Set location fields
        if (response.data.region) {
          setSelectedRegion(response.data.region);

          // Set available districts based on selected region
          if (madagascarData[response.data.region]) {
            const availableDistricts = Object.keys(
              madagascarData[response.data.region],
            );
            setDistricts(availableDistricts);
          }
        }

        if (response.data.district) {
          setSelectedDistrict(response.data.district);

          // Set available communes based on selected district
          if (madagascarData[response.data.region]?.[response.data.district]) {
            const availableCommunes =
              madagascarData[response.data.region][response.data.district];
            setCommunes(availableCommunes);
          }
        }

        if (response.data.province) {
          setSelectedCommune(response.data.province);
        }
      } catch (err) {
        setError(t("failed_fetch_user_data"));
        setLoading(false);
      }
    };

    fetchUserData();
  }, [setValue]);

  const [modificationData, setModificationData] = useState([]);
  const [hasSubmitted, setHasSubmitted] = useState(false);

  const toggleEditable = (field) => {
    setEditableFields((prev) => ({
      ...prev,
      [field]: !prev[field],
    }));
    setModificationData((prev) => {
      if (prev.includes(field)) {
        return prev.filter((item) => item !== field);
      } else {
        return [...prev, field];
      }
    });
  };

  const handleCloseModal = () => {
    if (modificationData.length === 0) {
      Swal.fire({
        icon: "warning",
        title: t("no_fields_selected"),
        text: t("no_fields_selected_text"),
        showCancelButton: true,
        confirmButtonText: t("select_fields"),
        cancelButtonText: t("go_back"),
      }).then((result) => {
        if (result.isDismissed) {
          history.push("/"); // or wherever you want to redirect
        }
      });
    } else {
      setShowModal(false);
    }
  };
  const handleCloseModal2 = () => {
    history.push("/");
  };

  function isValidDate(dateString) {
    var regEx = /^\d{4}-\d{2}-\d{2}$/;
    if (!dateString.match(regEx)) return false; // Invalid format
    var d = new Date(dateString);
    if (!d.getTime()) return false; // Invalid date (or this could be epoch)
    return d.toISOString().slice(0, 10) === dateString;
  }

  const onSubmit = (data) => {
    var firstName = data.firstName.trim();
    var lastName = data.lastName.trim();
    var dob = data.dob.trim();
    var houseAddress = data.houseAddress;
    var mydatenow = document.getElementById("dobinputtype").value;
    var nnn = mydatenow.split(/-/g);
    var newdate = [nnn[2], nnn[1], nnn[0]].join("-");
    // if (firstName === "") {
    //   Swal.fire({
    //     icon: "error",
    //     title: t("missing_first_name"),
    //     text: t("missing_first_name_text"),
    //   });
    //   return;
    // }
    // if (lastName === "") {
    //   Swal.fire({
    //     icon: "error",
    //     title: t("missing_last_name"),
    //     text: t("missing_last_name_text"),
    //   });
    //   return;
    // }

    // if (dob === "") {
    //   Swal.fire({
    //     icon: "error",
    //     title: t("missing_dob"),
    //     text: t("missing_dob_text"),
    //   });
    //   return;
    // }
    // if (houseAddress === "") {
    //   Swal.fire({
    //     icon: "error",
    //     title: t("missing_house_address"),
    //     text: t("missing_house_address_text"),
    //   });
    //   return;
    // }

    const newArray = Object.values(modificationData);
    const payload = {
      ...data,
      modificationData: newArray,
    };
    localStorage.setItem("dan", newdate);
    setHasSubmitted(true);
    dispatch(enrolUser(payload));
  };

  useEffect(() => {
    dispatch(clearState());
    return () => {
      dispatch(clearState());
    };
  }, []);

  useEffect(() => {
    if (isError && hasSubmitted) {
      toast.error(errorMessage);
      dispatch(clearState());
      history.push("/modification");
      setHasSubmitted(false);
    }
    if (isSuccess && hasSubmitted) {
      toast.success(successMessage);
      dispatch(clearState());
      history.push("/qrgenerator");
      setHasSubmitted(false);
    }
  }, [isError, isSuccess, hasSubmitted]);

  const [statesfromapi, setStatesfromapi] = useState([]);
  const [getstatesid, setGetstateid] = useState([]);
  const [getstatesoriginid, setGetstateoriginid] = useState([]);
  const [lgasfromapi, setLgasfromapi] = useState([]);
  const [lgasoriginfromapi, setLgasoriginfromapi] = useState([]);

  const [successfulresponse, setSuccessfulresponse] = useState(false);

  const countries = [
    { name: "Madagascar", code: "Mg" },
    { name: "Afghanistan", code: "AF" },
    { name: "Australia", code: "AU" },
    { name: "Austria", code: "AT" },
    { name: "Guernsey", code: "GG" },
    { name: "Guinea", code: "GN" },
    { name: "Guinea-Bissau", code: "GW" },
    { name: "Guyana", code: "GY" },
    { name: "Haiti", code: "HT" },
    { name: "Heard Island and Mcdonald Islands", code: "HM" },
    { name: "Holy See (Vatican City State)", code: "VA" },
    { name: "Honduras", code: "HN" },
    { name: "Hong Kong", code: "HK" },
    { name: "Hungary", code: "HU" },
    { name: "Iceland", code: "IS" },
    { name: "Japan", code: "JP" },
    { name: "Jersey", code: "JE" },
    { name: "Liechtenstein", code: "LI" },
    { name: "Lithuania", code: "LT" },
    { name: "Luxembourg", code: "LU" },
    { name: "Macao", code: "MO" },
    { name: "Macedonia, The Former Yugoslav Republic of", code: "MK" },
    { name: "Madagascar", code: "MG" },
    { name: "Malawi", code: "MW" },
    { name: "Malaysia", code: "MY" },
    { name: "Maldives", code: "MV" },
    { name: "Mali", code: "ML" },
    { name: "Malta", code: "MT" },
    { name: "Mexico", code: "MX" },
    { name: "Micronesia, Federated States of", code: "FM" },
    { name: "Moldova, Republic of", code: "MD" },
    { name: "Monaco", code: "MC" },
    { name: "Mongolia", code: "MN" },
    { name: "Montserrat", code: "MS" },
    { name: "Morocco", code: "MA" },
    { name: "Mozambique", code: "MZ" },
    { name: "Nigeria", code: "NG" },
    { name: "Niger", code: "NE" },
    { name: "Niue", code: "NU" },
    { name: "Norfolk Island", code: "NF" },
    { name: "Northern Mariana Islands", code: "MP" },
    { name: "Norway", code: "NO" },
    { name: "Zambia", code: "ZM" },
    { name: "Zimbabwe", code: "ZW" },
  ];

  let [caption, setCaption] = useState("House Rent");

  const inputHandler = (e) => {
    const { value, maxLength } = e.target;
    if (String(value).length >= maxLength) {
      e.preventDefault();
      return;
    }
  };
  const [isUnder18, setIsUnder18] = useState(false);
  const checkAge = (date) => {
    const today = new Date();
    const birthDate = new Date(date);
    let age = today.getFullYear() - birthDate.getFullYear();
    const m = today.getMonth() - birthDate.getMonth();
    if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
      age--;
    }
    setIsUnder18(age < 18);
  };

  const [regions, setRegions] = useState([]);
  const [selectedRegion, setSelectedRegion] = useState("");
  const [districts, setDistricts] = useState([]);
  const [selectedDistrict, setSelectedDistrict] = useState("");
  const [communes, setCommunes] = useState([]);
  const [selectedCommune, setSelectedCommune] = useState("");

  useEffect(() => {
    setRegions(Object.keys(madagascarData));
  }, []);

  const handleRegionChange = (event) => {
    const region = event.target.value;
    setSelectedRegion(region);
    if (madagascarData[region]) {
      setDistricts(Object.keys(madagascarData[region]));
      setValue("region", region);
    } else {
      setDistricts([]);
    }
    setSelectedDistrict("");
    setCommunes([]);
    setSelectedCommune("");
  };

  const handleDistrictChange = (event) => {
    const district = event.target.value;
    setSelectedDistrict(district);
    setValue("district", district);

    if (
      madagascarData[selectedRegion] &&
      madagascarData[selectedRegion][district]
    ) {
      setCommunes(madagascarData[selectedRegion][district]);
    } else {
      setCommunes([]);
    }
    setSelectedCommune("");
  };

  const handleCommuneChange = (event) => {
    const commune = event.target.value;
    setSelectedCommune(commune);
    setValue("province", commune);
  };

  const formatDate = (date) => {
    if (!date) return "";
    const [year, month, day] = date.split("-");
    return `${day}-${month}-${year}`;
  };

  const [formattedDob, setFormattedDob] = useState("");
  const [parentDob, setParentDob] = useState("");

  return (
    <Fragment>
      <AuthNavBar />
      {loading ? (
        <p>{t("loading_user_data")}</p>
      ) : error ? (
        <p>{error}</p>
      ) : (
        <>
          <div
            className={`modal fade ${showModal ? "show" : ""}`}
            style={{ display: showModal ? "block" : "none" }}
            tabIndex="-1"
            role="dialog"
            aria-labelledby="fieldSelectionModal"
            aria-hidden="true"
          >
            <div className="modal-dialog modal-dialog-centered">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title">{t("select_fields_to_modify")}</h5>
                  <button
                    type="button"
                    className="btn-close"
                    aria-label="Close"
                    onClick={handleCloseModal2}
                  ></button>
                </div>
                <div className="modal-body">
                  <div className="form-check mb-2">
                    <input
                      type="checkbox"
                      className="form-check-input"
                      id="firstName"
                      checked={editableFields.firstName}
                      onChange={() => toggleEditable("firstName")}
                    />
                    <label className="form-check-label" htmlFor="firstName">{t("first_name")}</label>
                  </div>
                  <div className="form-check mb-2">
                    <input
                      type="checkbox"
                      className="form-check-input"
                      id="lastName"
                      checked={editableFields.lastName}
                      onChange={() => toggleEditable("lastName")}
                    />
                    <label className="form-check-label" htmlFor="lastName">{t("last_name")}</label>
                  </div>
                  <div className="form-check mb-2">
                    <input
                      type="checkbox"
                      className="form-check-input"
                      id="dob"
                      checked={editableFields.dob}
                      onChange={() => toggleEditable("dob")}
                    />
                    <label className="form-check-label" htmlFor="dob">{t("dob")}</label>
                  </div>
                  <div className="form-check mb-2">
                    <input
                      type="checkbox"
                      className="form-check-input"
                      id="phoneNumber"
                      checked={editableFields.phoneNumber}
                      onChange={() => toggleEditable("phoneNumber")}
                    />
                    <label className="form-check-label" htmlFor="phoneNumber">{t("phone_number")}</label>
                  </div>
                  <div className="form-check mb-2">
                    <input
                      type="checkbox"
                      className="form-check-input"
                      id="email"
                      checked={editableFields.email}
                      onChange={() => toggleEditable("email")}
                    />
                    <label className="form-check-label" htmlFor="email">{t("email")}</label>
                  </div>
                  <div className="form-check mb-2">
                    <input
                      type="checkbox"
                      className="form-check-input"
                      id="gender"
                      checked={editableFields.gender}
                      onChange={() => toggleEditable("gender")}
                    />
                    <label className="form-check-label" htmlFor="gender">{t("gender")}</label>
                  </div>
                </div>
                <div className="modal-footer">
                  <button
                    type="button"
                    className="btn btn-primary"
                    onClick={handleCloseModal}
                  >{t("continue_btn")}</button>
                </div>
              </div>
            </div>
          </div>
          {showModal && <div className="modal-backdrop fade show"></div>}

          <div className="container">
            <h4 className="text-secondary mt-3">{t("modify_enrolment")}</h4>

            <div className="min-h-screen bg-gray-50 flex flex-col justify-center py-12 sm:px-6 lg:px-8 shadow-lg">
              <div className="card text-dark bg-light">
                <div className="card-body">
                  <div className="mb-3">
                    <legend className="custom-legend">{t("fields_to_be_modified")}</legend>
                    <label className="mr-3" style={{ marginRight: "20px" }}>
                      <input
                        type="checkbox"
                        checked={editableFields.firstName}
                        name="fChecked"
                        onChange={() => toggleEditable("firstName")}
                      />{" "}
                      {t("first_name")}
                    </label>
                    <label className="mr-2" style={{ marginRight: "20px" }}>
                      <input
                        type="checkbox"
                        checked={editableFields.lastName}
                        name="lChecked"
                        onChange={() => toggleEditable("lastName")}
                      />{" "}
                      {t("last_name")}
                    </label>
                    <label style={{ marginRight: "20px" }}>
                      <input
                        type="checkbox"
                        checked={editableFields.dob}
                        name="dChecked"
                        onChange={() => toggleEditable("dob")}
                      />{" "}
                      {t("dob")}
                    </label>
                    <label style={{ marginRight: "20px" }}>
                      <input
                        type="checkbox"
                        checked={editableFields.phoneNumber}
                        name="pChecked"
                        onChange={() => toggleEditable("phoneNumber")}
                      />{" "}
                      {t("phone_number")}
                    </label>
                  </div>

                  <form
                    className="space-y-6"
                    onSubmit={handleSubmit(onSubmit)}
                    method="POST"
                  >
                    <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                      <h5
                        className="card-title p-2"
                        style={{
                          backgroundColor: "rgba(10, 117, 22, 100)",
                          color: "#fff",
                        }}
                      >{t("demographic_data")}</h5>
                    </div>

                    <div className="row">
                      <div class="row">
                        <div
                          class="col-xs-12 col-sm-12 col-md-3 col-lg-3"
                          hidden={!editableFields.firstName}
                        >
                          <div className="mb-3 input-group-sm">
                            <label
                              for="exampleInputFirstName"
                              className="form-label"
                            >{t("first_name")}<span style={{ color: "red" }}>*</span>
                            </label>
                            <input
                              className="form-control"
                              id="firstName"
                              name="firstName"
                              type="text"
                              style={{ textTransform: "uppercase" }}
                              ref={register({ required: false })}
                              autocomplete="FirstName"
                            />
                          </div>
                        </div>
                        <div
                          class="col-xs-12 col-sm-12 col-md-3 col-lg-3"
                          hidden={!editableFields.lastName}
                        >
                          <div className="mb-3 input-group-sm">
                            <label
                              for="exampleInputLastName"
                              className="form-label"
                            >{t("surname")}<span style={{ color: "red" }}>*</span>
                            </label>
                            <input
                              className="form-control"
                              id="lastName"
                              type="text"
                              name="lastName"
                              style={{ textTransform: "uppercase" }}
                              ref={register({ required: false })}
                              autocomplete="lastName"
                            />
                          </div>
                        </div>

                        <div
                          class="col-xs-12 col-sm-12 col-md-3 col-lg-3"
                          hidden={!editableFields.dob}
                        >
                          <div className="mb-3 input-group-sm">
                            <label for="exampleInputDOB" className="form-label">
                              {t("dob")}{" "}
                              <span style={{ color: "red" }}>*</span>
                            </label>
                            <input
                              type="date"
                              className="form-control"
                              aria-describedby="DOBHelp"
                              ref={register({ required: false })}
                              id="dobinputtype"
                              name="dob"
                              onChange={(e) => {
                                const formattedDate = formatDate(
                                  e.target.value,
                                );
                                setFormattedDob(formattedDate);
                                checkAge(e.target.value);
                              }}
                            />
                            <input
                              type="text"
                              readOnly
                              hidden
                              value={formattedDob}
                              className="form-control mt-2"
                              placeholder="DD-MM-YYYY"
                            />
                          </div>
                        </div>
                        <div
                          class="col-xs-12 col-sm-12 col-md-3 col-lg-3"
                          hidden={!editableFields.gender}
                        >
                          <div className="mb-3 input-group-sm">
                            <label for="exampleInputDOB" className="form-label">{t("gender")}</label>
                            <select
                              className="form-select"
                              aria-label="Default select example"
                              id="gender"
                              name="gender"
                              style={{ textTransform: "uppercase" }}
                              ref={register({ required: false })}
                            >
                              <option selected>{t("select_gender")}</option>
                              <option value="male">{t("male")}</option>
                              <option value="female">{t("female")}</option>
                            </select>
                          </div>
                        </div>

                        <div
                          class="col-xs-12 col-sm-12 col-md-3 col-lg-3"
                          hidden={!editableFields.phoneNumber}
                        >
                          <div className="mb-3 input-group-sm">
                            <label
                              for="exampleInputEmail"
                              className="form-label"
                            >{t("telephone_number")}</label>
                            <input
                              type="number"
                              onKeyPress={inputHandler}
                              maxlength="11"
                              placeholder="0XXXXXXXXXXX"
                              className="form-control"
                              id="exampleInputDOB"
                              style={{ textTransform: "uppercase" }}
                              ref={register({ required: false })}
                              name="phoneNumber"
                              aria-describedby="DOBHelp"
                            />
                          </div>
                        </div>
                        <div
                          class="col-xs-12 col-sm-12 col-md-3 col-lg-3"
                          hidden={!editableFields.email}
                        >
                          <div className="mb-3 input-group-sm">
                            <label
                              for="exampleInputEmail"
                              className="form-label"
                            >{t("email")}</label>
                            <input
                              className="form-control"
                              id="email"
                              name="email"
                              type="text"
                              style={{ textTransform: "uppercase" }}
                              ref={register({ required: false })}
                              autocomplete="Email"
                            />
                          </div>
                        </div>
                        <div
                          class="col-xs-12 col-sm-12 col-md-3 col-lg-3"
                          hidden={true}
                        >
                          <div className="mb-3 input-group-sm">
                            <label
                              for="exampleInputEmail"
                              className="form-label"
                            >{t("maiden_name")}</label>
                            <input
                              type="text"
                              onKeyPress={inputHandler}
                              maxlength="11"
                              className="form-control"
                              id="exampleInputDOB"
                              style={{ textTransform: "uppercase" }}
                              ref={register({ required: false })}
                              name="maidenName"
                              aria-describedby="DOBHelp"
                            />
                          </div>
                        </div>
                        <div
                          class="col-xs-12 col-sm-12 col-md-3 col-lg-3"
                          hidden={true}
                        >
                          <div className="mb-3 input-group-sm">
                            <label for="exampleInputDOB" className="form-label">{t("contact_owner")}</label>
                            <select
                              className="form-select"
                              aria-label="Default select example"
                              id="contactOwner"
                              name="contactOwner"
                              style={{ textTransform: "uppercase" }}
                              ref={register({ required: false })}
                            >
                              <option selected>{t("select_contact_owner")}</option>
                              <option value="personal">{t("personal")}</option>
                              <option value="chef_of_fokontany">
                                {t("chief_of_fokontany")}
                              </option>
                              <option value="community_leader">{t("community_leader")}</option>
                              <option value="other">{t("other")}</option>
                            </select>
                          </div>
                        </div>
                        {isUnder18 && (
                          <>
                            <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3">
                              <div className="mb-3 input-group-sm">
                                <label for="parentName" className="form-label">{t("parent_last_name")}</label>
                                <input
                                  type="text"
                                  className="form-control"
                                  id="parentLastName"
                                  name="parentLastName"
                                  ref={register({ required: isUnder18 })}
                                />
                              </div>
                            </div>
                            <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3">
                              <div className="mb-3 input-group-sm">
                                <label for="parentName" className="form-label">{t("parent_first_name")}</label>
                                <input
                                  type="text"
                                  className="form-control"
                                  id="parentFirstName"
                                  name="parentFirstName"
                                  ref={register({ required: isUnder18 })}
                                />
                              </div>
                            </div>
                            <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3">
                              <div className="mb-3 input-group-sm">
                                <label
                                  for="exampleInputDOB"
                                  className="form-label"
                                >{t("parent_dob")}</label>

                                <input
                                  type="date"
                                  className="form-control"
                                  aria-describedby="DOBHelp"
                                  id="parentDob"
                                  name="parentDob"
                                  onChange={(e) => {
                                    const formattedDate = formatDate(
                                      e.target.value,
                                    );
                                    setParentDob(formattedDate);
                                  }}
                                  ref={register({ required: false })}
                                />
                                <input
                                  type="text"
                                  className="form-control mt-2"
                                  value={parentDob}
                                  placeholder="DD-MM-YYYY"
                                  readOnly
                                  hidden
                                />
                              </div>
                            </div>
                          </>
                        )}
                        <div
                          class="col-xs-12 col-sm-12 col-md-3 col-lg-3"
                          style={{ display: "none" }}
                        >
                          <div className="mb-3 input-group-sm">
                            <label for="parentName" className="form-label">{t("enrollment_type")}</label>
                            <input
                              type="text"
                              className="form-control"
                              id="enrolmentType"
                              name="enrolmentType"
                              value={
                                isUnder18
                                  ? "ER-MODIFICATION"
                                  : "CR-MODIFICATION"
                              }
                              ref={register({ required: false })}
                            />
                          </div>
                        </div>
                        <div
                          class="col-xs-12 col-sm-12 col-md-3 col-lg-3"
                          hidden={true}
                        >
                          <div className="mb-3 input-group-sm">
                            <label for="parentName" className="form-label">
                              {t("nui")}
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              id="nui"
                              name="nui"
                              ref={register({ required: false })}
                            />
                          </div>
                        </div>
                      </div>

                      <div
                        class="col-xs-12 col-sm-12 col-md-12 col-lg-12"
                        hidden={true}
                      >
                        <h5
                          className="card-title p-2"
                          style={{
                            backgroundColor: "rgba(10, 117, 22, 100)",
                            color: "#fff",
                          }}
                        >{t("residence_address_data")}</h5>
                      </div>
                      <div class="row">
                        <div
                          class="col-xs-12 col-sm-12 col-md-3 col-lg-3"
                          hidden={true}
                        >
                          <div className="mb-3 input-group-sm">
                            <label
                              for="exampleInputEmail"
                              className="form-label"
                            >{t("residence_address")}<span style={{ color: "red" }}>*</span>
                            </label>
                            <textarea
                              className="form-control"
                              aria-label="With textarea"
                              name="residenceAddress"
                              id="residenceAddress"
                              style={{ textTransform: "uppercase" }}
                              ref={register({ required: false })}
                            ></textarea>
                          </div>
                        </div>

                        <div
                          className="col-xs-12 col-sm-12 col-md-3 col-lg-3"
                          hidden={true}
                        >
                          <div className="mb-3 input-group-sm">
                            <label
                              for="exampleInputEmail"
                              className="form-label"
                            >{t("residence_address_town")}</label>
                            <textarea
                              className="form-control"
                              aria-label="With textarea"
                              name="houseAddress"
                              style={{ textTransform: "uppercase" }}
                            ></textarea>
                          </div>
                        </div>
                        <div
                          className="col-xs-12 col-sm-12 col-md-3 col-lg-3"
                          hidden={true}
                        >
                          <div className="mb-3 input-group-sm">
                            <label htmlFor="region" className="form-label">{t("region")}</label>
                            <select
                              className="form-control"
                              name="region"
                              ref={register({ required: false })}
                              id="region"
                              value={selectedRegion}
                              onChange={handleRegionChange}
                            >
                              <option value="">{t("select_region")}</option>
                              {regions.map((region) => (
                                <option key={region} value={region}>
                                  {region}
                                </option>
                              ))}
                            </select>
                          </div>
                        </div>

                        <div
                          className="col-xs-12 col-sm-12 col-md-3 col-lg-3"
                          hidden={true}
                        >
                          <div className="mb-3 input-group-sm">
                            <label htmlFor="district" className="form-label">{t("district")}</label>
                            <select
                              className="form-control"
                              name="district"
                              ref={register({ required: false })}
                              id="district"
                              value={selectedDistrict}
                              onChange={handleDistrictChange}
                              disabled={!selectedRegion}
                            >
                              <option value="">{t("select_district")}</option>
                              {districts.map((district) => (
                                <option key={district} value={district}>
                                  {district}
                                </option>
                              ))}
                            </select>
                          </div>
                        </div>

                        <div
                          className="col-xs-12 col-sm-12 col-md-3 col-lg-3"
                          hidden={true}
                        >
                          <div className="mb-3 input-group-sm">
                            <label htmlFor="commune" className="form-label">{t("province")}</label>
                            <select
                              className="form-control"
                              name="province"
                              ref={register({ required: false })}
                              id="province"
                              disabled={!selectedDistrict}
                            >
                              <option value="">{t("select_province")}</option>
                              {communes.map((commune) => (
                                <option key={commune} value={commune}>
                                  {commune}
                                </option>
                              ))}
                            </select>
                          </div>
                        </div>

                        <div
                          className="col-xs-12 col-sm-12 col-md-3 col-lg-3"
                          hidden={true}
                        >
                          <div className="mb-3 input-group-sm">
                            <label for="exampleInputDOB" className="form-label">{t("place_of_birth")}</label>
                            <select
                              className="form-select"
                              aria-label="Default select example"
                              name="placeOfBirth"
                              id="placeOfBirth"
                              ref={register({ required: false })}
                              style={{ textTransform: "uppercase" }}
                            >
                              {countries.map((country, index) => {
                                return (
                                  <option
                                    key={country.name}
                                    value={country.name}
                                  >
                                    {countryLabel(country)}
                                  </option>
                                );
                              })}
                            </select>
                          </div>
                        </div>
                      </div>
                    </div>

                    <button
                      type="submit"
                      className="btn btn-success w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                    >
                      {isFetching ? (
                        <Fragment>
                          <svg
                            className="animate-spin -ml-1 mr-3 h-5 w-5 text-white"
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 24 24"
                          >
                            <circle
                              className="opacity-25"
                              cx="12"
                              cy="12"
                              r="10"
                              stroke="currentColor"
                              strokeWidth="4"
                            ></circle>
                            <path
                              className="opacity-75"
                              fill="currentColor"
                              d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                            ></path>
                          </svg>

                          <p>{t("requesting_modification")}</p>
                        </Fragment>
                      ) : (
                        <span>{t("submit")}</span>
                      )}
                    </button>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </Fragment>
  );
};

export default ModifyBiodata;
